import React, { useEffect, useState } from 'react';
import styles from './OurStory.module.css';
import { getOurStoryContent } from '../../services/contentService';
import { CustomButton, CustomFooter, CustomImage, CustomLoader, CustomMoreSection, CustomScrollIndicator, CustomTextMarkdown, CustomTitle } from '../../components';
import { ReactComponent as ArrowRightDark } from '../../assets/icons/arrow_right_dark.svg';
import { useTranslation } from 'react-i18next';
import colors from '../../styles/colors';

const OurStory = () => {

    const {t} = useTranslation();

    const [pageContent, setPageContent] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        handleGetOurStoryContent();
    }, []);

    const handleGetOurStoryContent = async () => {
        try {
            setIsLoading(true);

            const content = await getOurStoryContent();
            setPageContent(content);
            
            const homeImg = new Image();
            homeImg.onload = () => setIsLoading(false);
            homeImg.src = `${process.env.REACT_APP_API_BASE_URL}${content.A_block_image.url}`;
        } catch(e) {
            console.error(e);
            throw e;
        }
    }
    
    return (
        <div className={styles.container}>

            { !isLoading &&
                <>
                    <div className={styles.A_block}>
                        <div className={styles.A_block_container_title}>
                            <div className={styles.left_spacer}></div>

                            <div className={styles.A_block_center_title}>
                                <CustomTitle isSubtitle className={styles.A_block_subtitle}>{pageContent.A_block_subtitle}</CustomTitle>
                                <CustomTitle center>{pageContent.A_block_title}</CustomTitle>
                            </div>
                            
                            <div className={styles.A_block_scroll_ind_container}>
                                <CustomScrollIndicator />
                            </div>
                        </div>

                        <div className={styles.A_block_img_container}>
                            <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.A_block_image?.url}`} alt="" />
                        </div>

                        <CustomTextMarkdown className={styles.A_block_paragraph}>{pageContent.A_block_paragraph}</CustomTextMarkdown>
                    </div>


                    <div className={styles.B_block}>
                        <div className={styles.B_block_left_container}>
                            <CustomTitle isSubtitle className={styles.B_block_subtitle}>{pageContent.B_block_subtitle}</CustomTitle>
                            <CustomTextMarkdown components={{ p : 'h2' }} className={styles.B_block_title}>{pageContent.B_block_title}</CustomTextMarkdown>
                            <CustomTextMarkdown className={styles.B_block_A_paragraph}>{pageContent.B_block_A_paragraph}</CustomTextMarkdown>
                        </div>

                        <div className={styles.B_block_right_container}>
                            <div className={styles.B_block_right_subcontainer}>
                                <CustomTextMarkdown>{pageContent.B_block_B_paragraph}</CustomTextMarkdown>
                                <CustomButton
                                    buttonType="outlined"
                                    color={colors.darkBlue}
                                    endIcon={<ArrowRightDark />}
                                    onClick={() => console.log()}>
                                    {t('our_story.who_is_for')}
                                </CustomButton>
                            </div>

                            <div className={styles.B_block_right_subcontainer}>
                                <CustomTextMarkdown>{pageContent.B_block_C_paragraph}</CustomTextMarkdown>
                                <CustomButton
                                    buttonType="outlined"
                                    color={colors.darkBlue}
                                    endIcon={<ArrowRightDark />}
                                    onClick={() => console.log()}>
                                    {t('general.learn_more')}
                                </CustomButton>
                            </div>
                        </div>
                    </div>


                    <div className={styles.C_block}>
                        <CustomTitle isSubtitle className={styles.C_block_subtitle}>{pageContent.C_block_subtitle}</CustomTitle>
                        <CustomTextMarkdown className={styles.C_block_title} components={{ p : 'h2' }}>{pageContent.C_block_title}</CustomTextMarkdown>

                        <div className={styles.C_block_content}>
                            <div className={styles.C_block_img}>
                                <CustomImage src={`${process.env.REACT_APP_API_BASE_URL}${pageContent.C_block_image?.url}`} alt="" />
                            </div>

                            <CustomTextMarkdown className={styles.C_block_paragraph}>{pageContent.C_block_paragraph}</CustomTextMarkdown>
                        </div>
                    </div>


                    <div className={styles.D_block}>
                        <div>
                            <CustomTitle isSubtitle className={styles.D_block_subtitle}>{pageContent.D_block_subtitle}</CustomTitle>
                            <CustomTextMarkdown className={styles.D_block_title} components={{ p : 'h2' }}>{pageContent.D_block_title}</CustomTextMarkdown>
                        </div>

                        <div>
                            <CustomTextMarkdown className={styles.D_block_paragraph}>{pageContent.D_block_paragraph}</CustomTextMarkdown>
                        </div>
                    </div>
                    
                    <CustomMoreSection />
                    <CustomFooter />
                </>
            }
            
            { isLoading &&
                <div className={styles.container_loader}>
                    <CustomLoader loaderType="skeleton" isLoading={isLoading}/>
                </div>
            }
        
        </div>
    )
}

export default OurStory;